import { render } from "./SessionScheduleMenu.vue?vue&type=template&id=8ca37b98"
import script from "./SessionScheduleMenu.vue?vue&type=script&lang=js"
export * from "./SessionScheduleMenu.vue?vue&type=script&lang=js"

import "./SessionScheduleMenu.vue?vue&type=style&index=0&id=8ca37b98&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__